/* eslint eqeqeq: 0 */
import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { languageService } from "../../../../Language/language.service";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { MyPlanningTableStyle } from "../../../Dashboard/styles/MyPlanningTableStyle";
import ThisTable from "../../../Common/ThisTable";
import moment from "moment";
import { commonStylesDashboard } from "../../../Dashboard/styles/commonStylesDashboard";
import { DashboardPageStyle } from "../../../Dashboard/styles/DashboardPageStyle";
import { dateSort } from "../../../../utils/sortingMethods";
import { formatIssueTimeStamp } from "../../../../utils/issueDateUtil";
import { generalSortUsingArrayIndex, WorkerOrderStateSortSequence } from "../../../../utils/sortingMethods";
import { statusStyle } from "../../../JourneyPlan/JourneyPlanList/style";
import { getIssueMPMethods } from "../../../Common/services/mileposts";
import { UtilFunctions } from "../../../Reports/WorkOrderReport/CommonUtilFunction";

class MaintenanceTable extends Component {
  constructor(props) {
    super(props);
    // define your columns here
    this.columns = [
      {
        id: "mrNumber",
        Header: languageService("MR#"),
        accessor: (d) => d.mrNumber,
        Cell: ({ value }) => <div style={{ fontSize: "12px" }}>{value || ""}</div>,
        minWidth: 100,
      },
      {
        id: "issueNum",
        Header: languageService("Issue#"),
        minWidth: 100,
        accessor: (d) => {
          if (d.issue && d.issue.serverObject && d.issue.serverObject.issueNum) return d.issue.serverObject.issueNum;

          return "N/A";
        },
      },
      {
        Header: languageService("Asset Name"),
        title: "trackId",
        accessor: (d) => {
          if (d.issue && d.issue.unit && d.issue.unit.unitId) {
            return d.issue.unit.unitId;
          }
          return "N/A";
        },
        id: "trackId",
        minWidth: 150,
      },
      {
        id: "locLine",
        Header: languageService("Location"),
        minWidth: 200,
        accessor: (d) => {
          if (d.lineName) return d.lineName;

          return "";
        },
      },
      {
        Header: "Mile Post",
        id: "milePosts",
        accessor: (row) => {
          if (!row.issue) return "";
          const { issue } = row;
          const { startMp, endMp } = UtilFunctions.getMPS({}, row);
          let isLinear = issue.startMp && issue.endMp ? true : false;
          const returnValue = isLinear ? `${startMp} - ${endMp}` : startMp;
          return returnValue;
        },
        sortMethod: (a, b) => {
          const getFirstNumber = (str) => {
            const match = str.split(" ");
            let x = match ? parseFloat(match[0]) : Number.POSITIVE_INFINITY;
            if (isNaN(x)) {
              return Number.POSITIVE_INFINITY;
            }
            return x;
          };
          const firstNumberA = getFirstNumber(a);
          const firstNumberB = getFirstNumber(b);
          return firstNumberA - firstNumberB;
        },
      },
      {
        id: "description",
        Header: languageService("Description"),
        accessor: function (d) {
          return d && d.issue ? d.issue.description : "";
        },
        Cell: ({ value }) => <div style={{ fontSize: "12px" }}>{value || ""}</div>,
        minWidth: 150,
      },

      {
        Header: languageService("Date Created"),
        id: "timestamp",
        minWidth: 120,
        sortMethod: dateSort,
        accessor: (d) => {
          if (d.issue && d.issue.remedialAction && d.issue.remedialAction === "Repaired" && d.issue.timeStamp) {
            return d.issue.timeStamp;
          }

          if (d.createdAt) {
            return d.createdAt;
          }

          return "";
        },
        Cell: (_props) => {
          const { original, value } = _props;
          const d = original;

          let timestamp = "";

          if (d.issue && d.issue.remedialAction && d.issue.remedialAction === "Repaired" && d.issue.timeStamp) {
            timestamp = d.issue.timeStamp;
          } else if (d.createdAt) {
            timestamp = d.createdAt;
          }

          if (!timestamp) return "";

          return moment.utc(timestamp).local().format("ddd, MMM D YYYY");
        },
      },
      {
        Header: languageService("Status"),
        id: "status",
        width: 130,
        sortMethod: (a, b) => generalSortUsingArrayIndex(a, b, WorkerOrderStateSortSequence),
        accessor: (d) => {
          let status = "Unknown";
          if (d.status) {
            status = d.status;
          }
          return status;
        },
        Cell: (_props) => {
          const { value } = _props;

          return <div style={themeService(statusStyle.statusColorStyle(value, this.props))}>{languageService(value)}</div>;
        },
      },
    ];
  }

  render() {
    const { maintenanceList, pageSize, pagination } = this.props;

    return (
      <Col md="12">
        <Row style={themeService(MyPlanningTableStyle.planningTableContainerMargin)}>
          <div style={{ padding: "0px 0px 0px", width: "-webkit-fill-available", width: "100%" }}>
            <div style={{ boxShadow: "3px 3px 5px #cfcfcf" }}>
              <ThisTable
                tableColumns={this.columns}
                tableData={maintenanceList}
                pageSize={pageSize || 10}
                pagination={pagination !== false}
                minRows={pageSize || 10}
                showFilters={false}
                classNameCustom="fillFullHeight"
                forDashboard={true}
                height={"auto"}
                fromDashboardToLink={"/maintenancebacklog"}
              />
            </div>
          </div>
        </Row>
      </Col>
    );
  }
}

export default MaintenanceTable;



// WEBPACK FOOTER //
// ./src/components/NewDashboard/widgets/MaintenanceListWidget/MaintenanceTable.jsx